import { posthog } from '../posthogClient';

const APP = 'cv_analyzer';

function hasPosthog() {
  return Boolean(process.env.REACT_APP_POSTHOG_KEY);
}

/** @param {string} event @param {Record<string, unknown>} [props] */
export function captureProductEvent(event, props = {}) {
  if (!hasPosthog()) return;
  try {
    posthog.capture(event, { app_name: APP, ...props });
  } catch (e) {
    console.warn('[PostHog]', e);
  }
}

/** @param {{ id?: string|number, email?: string, username?: string }} user */
export function identifyProductUser(user) {
  if (!hasPosthog() || !user?.id) return;
  try {
    posthog.identify(String(user.id), {
      email: user.email,
      username: user.username,
      app_name: APP,
    });
  } catch (e) {
    console.warn('[PostHog identify]', e);
  }
}

export function resetProductUser() {
  if (!hasPosthog()) return;
  try {
    posthog.reset();
    posthog.register({ app_name: APP });
  } catch (e) {
    console.warn('[PostHog reset]', e);
  }
}

export function trackCvAnalysisStarted(props = {}) {
  captureProductEvent('cv_analysis_started', props);
}

export function trackCvAnalysisCompleted(props = {}) {
  captureProductEvent('cv_analysis_completed', props);
}

export function trackCvAnalysisFailed(reason, extra = {}) {
  captureProductEvent('cv_analysis_failed', { reason, ...extra });
}

export function trackCreditsInsufficient(feature = 'cv_analysis') {
  captureProductEvent('credits_insufficient', { feature });
}

export function trackSubscriptionCtaClick(source) {
  captureProductEvent('subscription_cta_click', { source });
}

export function trackSubscriptionCheckoutStarted() {
  captureProductEvent('subscription_checkout_started');
}

export function trackUserRegistered() {
  captureProductEvent('user_registered');
}

export function trackUserLoggedIn() {
  captureProductEvent('user_logged_in');
}
